import PropTypes from 'prop-types';

var propTypes = {
    selection: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        selected: PropTypes.bool,
        label: PropTypes.node,
    })).isRequired,
    enableSelectAll: PropTypes.bool,
    onSelectionChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    withDividers: PropTypes.bool,
    labelForSelectAll: PropTypes.string,
    'data-testid': PropTypes.string,
};
var defaultProps = {
    className: '',
    enableSelectAll: false,
    withDividers: true,
    labelForSelectAll: 'Select All',
};

export { defaultProps, propTypes };
